import Wrapper from './swrapper';

export default Wrapper;



// WEBPACK FOOTER //
// ./src/pages/profile/components/wrapper/index.ts